import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useParams } from "react-router-dom";
import { UiSelect, UiInput, UiDatePicker, BgLoader, UiButton, OverlayLoader } from "../ui";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStore } from "../state.js";


const Company = NiceModal.create(
  ({ id, subtitle, action, bgColor, note = "", data }) => {
    const [input, setInput] = useState(note);
    const [state, setState] = useState({ count: 0 });
    const [entry, setEntry] = useState([]);
    const modal = useModal();
    const zstate = useStore((state) => state.categories);
    const mstate = useStore((state) => state.machines);
    const setZState = useStore((state) => state.setGroups);
    const schema = yup.object().shape({
      name: yup.string().required("Enter name of company"),
      state: yup.string().required("Select state"),
      start_from: yup.string().nullable().required("Select date"),

    }, []);
    const {
      register,
      handleSubmit,
      control,
      unregister,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const onSubmitHandler = async (data) => {
      SaveTag(data);
      //reset();
    };
    var SaveTag = (e) => {
      setState({ ...state, loader: true });

      instance({
        method: "post",
        url: "/update_company",
        data: e,
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          setState({ ...state, loader: false });
          if (response.data.status == "error") {
            toast(response.data.msg, { type: "error" });
          }
          if (response.data.status == "success") {
            toast(response.data.msg, { type: "success" });
            modal.resolve({ resolved: true });
            modal.hide();
          }
        })
        .catch(function (response) { });
    };


    const fetchData = () => {
      instance
        .get("/get_company?id=" + id)
        .then(function (response) {
          setState(response.data)
          reset(response.data.item)
        })
        .catch(function (error) { })
        .then(function () { });
    }



    useEffect(() => {
      fetchData()



    }, []);



    const handleHide = () => {
      modal.hide();
    }




    return (
      <BootstrapModal {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Company</BootstrapModal.Title>
        </BootstrapModal.Header>
        <OverlayLoader visible={state.loader} />
        <BootstrapModal.Body>
          {state.status ?
            <form id="Companyform" onSubmit={handleSubmit(onSubmitHandler)}>

              <UiInput
                label="Name"
                required
                type="text"
                name="name"
                {...register("name")}
                message={errors.name?.message}
              />




              <UiSelect
                name='state'
                label="State"
                required
                message={errors.state?.message}
                options={state.state}
                {...register(`state`)}
              />


              <Controller

                name="start_from"
                control={control}
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { invalid, isTouched, isDirty, error },
                  formState,
                }) => (
                  <UiDatePicker
                    onChange={(date) => { onChange(date); }}
                    required={true}
                    disabled={id =='new' ? false : true}
                    label="Books Start From"
                    default_val={value}
                    message={errors.start_from?.message}
                    dateFormat="dd-MM-yyyy"
                    ref={ref}
                    name={name}



                  />
                )}
              />





              <input type="hidden" value={id} name="id" {...register("id")} />
              <UiButton className="btn btn-primary" type="submit" title="Save" />

            </form>
            : <BgLoader />}
        </BootstrapModal.Body>

      </BootstrapModal>
    );
  }
);

export default Company;
